import { connect } from 'react-redux';
import { getPendingSearchParameters } from '../../../Search/state';
import ThemedSearchPanel from './ThemedSearchPanel';
import {
    trackThemedSearch,
    trackThemedSearchClick,
    updateParameters,
} from '../../../Search/actions';

const mapStateToProps = state => {
    const pendingSearchParameters = getPendingSearchParameters(state);

    return {
        pendingSearchParameters,
    };
};

const mapDispatchToProps = {
    trackThemedSearch,
    trackThemedSearchClick,
    updateParameters,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemedSearchPanel);
